var render, staticRenderFns
import script from "./ChartPolicyViolationsState.vue?vue&type=script&lang=js&"
export * from "./ChartPolicyViolationsState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea695f0')) {
      api.createRecord('5ea695f0', component.options)
    } else {
      api.reload('5ea695f0', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/ChartPolicyViolationsState.vue"
export default component.exports